import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'

export const TextHeaderEs = () => {
    return (
        <HighlightedText
            text="RECLAMA TU BONO"
            highlights={[{ word: 'TU' }, { word: 'BONO' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEs = () => {
    return (
        <HighlightedText
            text="325% de bono + 400 giros gratis"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['bono']}
            className={styles['text_content--FOURTH']}
        />
    )
}
